/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';
import { Typography2 } from '@coursera/cds-core';

import ContextualHelpDialog from 'bundles/program-loggedin-shared/components/ContextualHelpDialog';

import _t from 'i18n!nls/degree-home';

const styles = {
  duplicateCourseTitle: (theme: Theme) => css`
    ${theme.breakpoints.down('xs')} {
      margin-bottom: ${theme.spacing(24)};
      padding: ${theme.spacing(0, 24)};
    }
  `,
  content: (theme: Theme) => css`
    margin-bottom: ${theme.spacing(16)};
  `,
};

const DuplicateCoursesDialog: React.FC = () => {
  return (
    <div css={styles.duplicateCourseTitle}>
      <ContextualHelpDialog
        label={
          <Typography2 variant="bodyPrimary" component="span">
            {_t('There are duplicated courses in this program')}
          </Typography2>
        }
        dialogHeading={_t('Disclaimers')}
        ariaLabel={_t('View disclaimer')}
        data-testid="info-icon"
      >
        <Typography2 component="p" css={styles.content}>
          {_t(
            /* eslint-disable-next-line no-restricted-syntax */
            'When a course is offered in multiple segments and you complete it, your progress will count towards the completion of all segments where the course is available. However, it will only count once towards your graduation.'
          )}
        </Typography2>
      </ContextualHelpDialog>
    </div>
  );
};

export default DuplicateCoursesDialog;
